import {Image, useProductOptions} from '@shopify/hydrogen';
import clsx from 'clsx';

//types
import type {
  Maybe,
  Image as ImageProps,
} from '@shopify/hydrogen/storefront-api-types';

interface ColourOptionsWithThumbnail {
  colour: string;
  thumbnail: Maybe<ImageProps> | undefined;
  available?: boolean;
  sizes?: {size: string | undefined; available: boolean}[];
}

export default function ProductDetailsOptionsColour({
  name,
  values,
  allColourOptionsWithThumbnail,
}: {
  name: string;
  values: string[];
  allColourOptionsWithThumbnail?: ColourOptionsWithThumbnail[] | undefined;
}) {
  const {setSelectedOption, selectedOptions} = useProductOptions();

  const handleChange = (optionName: string, optionValue: string) => {
    if (setSelectedOption) {
      setSelectedOption(optionName, optionValue);
    }
  };

  return (
    <fieldset key={name} className="my-2 md:max-w-[400px]">
      {/* Name */}
      <ul className="grid grid-cols-5 gap-1 md:gap-2 lg:gap-1">
        {values.map((value, index) => {
          const checked = selectedOptions?.[name] === value;
          const id = `option-${name}-${value}`;

          const correspondingColourOption = allColourOptionsWithThumbnail
            ? Array.isArray(allColourOptionsWithThumbnail) &&
              allColourOptionsWithThumbnail?.find(
                (option) => option.colour === value,
              )
            : undefined;

          const thumbnail = correspondingColourOption
            ? correspondingColourOption.thumbnail
            : undefined;

          return (
            <li
              key={`${id}-${index}`}
              className={clsx([
                'product-variant group cursor-pointer overflow-hidden rounded-full border-[1px] border-solid border-slate-200 p-1.5',
                correspondingColourOption && correspondingColourOption.available
                  ? ''
                  : 'pointer-events-none opacity-25',
                checked && 'border-2 !border-black',
              ])}
            >
              <button
                className="block w-full"
                title={
                  correspondingColourOption &&
                  correspondingColourOption.available
                    ? correspondingColourOption.colour
                    : 'Out of Stock'
                }
              >
                <div className="product-variant__image aspect-w-16 aspect-h-16 overflow-hidden">
                  <div className="transition-transform duration-200 ease-out group-hover:scale-110">
                    <label key={id} htmlFor={id}>
                      <input
                        className="sr-only"
                        type="radio"
                        id={id}
                        name={`option[${name}]`}
                        value={value}
                        checked={checked}
                        onChange={() => handleChange(name, value)}
                      />
                      {thumbnail && (
                        <Image
                          data={{
                            url: thumbnail.url ?? '',
                            altText: name,
                          }}
                          width={150}
                          height={150}
                        />
                      )}
                      {/* <OptionButton checked={checked} label={value} /> */}
                    </label>
                  </div>
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    </fieldset>
  );
}
